interface GetCpqaOrderSummary {
  lineItems?: Array<{
    pricing?: Record<any, any> | undefined | null;
  }>;
}

// same logic as in @seek/hirer-ecommerce package - HirerOrderSummary
export const getIsCpqa = (orderSummary: GetCpqaOrderSummary) => {
  const result =
    orderSummary?.lineItems?.find(
      (item) => item.pricing?.__typename === 'CappedUnitPrice',
    ) ||
    orderSummary?.lineItems?.find(
      (item) => item.pricing?.type === 'CappedUnitPrice',
    );
  return Boolean(result);
};
